import { render, staticRenderFns } from "./PrescriptionHistory.vue?vue&type=template&id=495fb11a&"
import script from "./PrescriptionHistory.vue?vue&type=script&lang=js&"
export * from "./PrescriptionHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports